module.exports = __webpack_public_path__ + "img/support_icn.fa44a783.svg";